export const ANEXOS_ADICIONAR = "Adicionar Arquivo";
export const ANEXOS_LOADING_LABEL = "Carregando anexos...";
export const ANEXOS_VAZIO_TITULO = "Nenhum arquivo anexado.";
export const ANEXOS_DICA_ANTES = "Clique em ";
export const ANEXOS_DICA_DEPOIS = " para anexar.";

export const ANEXO_VER_LABEL = "Ver arquivo";
export const ANEXO_BAIXAR_LABEL = "Baixar arquivo";
export const ANEXO_REMOVER_LABEL = "Remover arquivo";

/** Toasts: sucesso por 4 s e erro por 5 s, como na geração da ficha. */
export const ANEXO_TOAST_SUCESSO_LIFE = 4000;
export const ANEXO_TOAST_ERRO_LIFE = 5000;

/** Regras da inclusão de anexo na ficha (HU 2688), passadas ao `AnexoDialog` do shared. */
export const FICHA_ANEXO_DIALOG_PROPS = {
  title: "Adicionar Arquivo",
  identificacaoLabel: "Identificação do documento",
  identificacaoMax: 500,
  /** Definidas pelo time; `jpg` e `jpeg` são o mesmo formato. */
  extensoes: ["jpg", "jpeg", "png", "pdf", "xlsx", "docx"],
  tamanhoMaxMb: 20,
  dica: "JPEG, PNG, PDF, XLSX ou DOCX, até 20 MB",
  mensagens: {
    formatoInvalido: "Formato não aceito. Use JPEG, PNG, PDF, XLSX ou DOCX.",
  },
  testIdPrefix: "ficha-anexo",
} as const;
